const config = require("./config");
const serialize = require("locutus/php/var/serialize");
const unserialize = require("locutus/php/var/unserialize");
const Utils = require("../../Utils");
import SubscribeForm from "../Newsletter/SubscribeForm";
import UnsubscribeForm from "../Newsletter/UnsubscribeForm";
function executeUnsubscribeConfirmAction(userId, websiteDomain, pageLang) {
  return new Promise((resolve, reject) => {
    let data = {
      data: serialize({
        action: "unsubscribeconfirm",
        params: [{
          responseType: "plain",
          lang: pageLang,
          client_domain: websiteDomain,
          user: userId
        }]
      })
    };

    // Default options are marked with *
    fetch(config.getNewsletterBrandedUrl(), {
      method: "POST",
      // *GET, POST, PUT, DELETE, etc.
      mode: "cors",
      // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      redirect: "follow",
      // manual, *follow, error
      referrerPolicy: "no-referrer",
      // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: `data=${data.data}` // body data type must match "Content-Type" header
    }).then(_res => {
      _res.text().then(function (data) {
        resolve(data);
      });
    }).catch(reject);
  });
}
function executeConfirmAction(userId, websiteDomain, pageLang) {
  return new Promise((resolve, reject) => {
    let data = {
      data: serialize({
        action: "confirmsubscribe",
        params: [{
          responseType: "plain",
          lang: pageLang,
          client_domain: websiteDomain,
          user: userId
        }]
      })
    };

    // Default options are marked with *
    fetch(config.getNewsletterBrandedUrl(), {
      method: "POST",
      // *GET, POST, PUT, DELETE, etc.
      mode: "cors",
      // no-cors, *cors, same-origin
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      redirect: "follow",
      // manual, *follow, error
      referrerPolicy: "no-referrer",
      // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: `data=${data.data}` // body data type must match "Content-Type" header
    }).then(_res => {
      _res.text().then(function (data) {
        resolve(data);
      });
    }).catch(reject);
  });
}
const initConfirmAction = function () {
  // activate forms confirm
  var query = Utils.getQueryParams(document.location.search);
  if (query.action && query.action === "confirm" && query.user) {
    // get the first form inside the page
    let newsletterForms = document.querySelectorAll('[data-newsletter-form-wrapper][data-form-type="subscribe"]');
    let websiteDomain = newsletterForms[0].getAttribute("data-website-domain");
    let pageLang = newsletterForms[0].getAttribute("data-page-lang");
    let child = document.createElement("div");
    child.setAttribute("data-result-container", "");
    child.innerHTML = "Loading...";
    newsletterForms[0].appendChild(child);
    // try to confirm the form subscription
    executeConfirmAction(query.user, websiteDomain, pageLang).then(res => {
      let resUnserialized = unserialize(res);
      let resultText = unserialize(resUnserialized.result);
      console.log(resultText);
      newsletterForms[0].querySelector("[data-result-container]").remove();
      let c = document.createElement("div");
      c.innerHTML = resultText;
      newsletterForms[0].appendChild(c);
    }).catch(e => {});
  }
  if (query.action && query.action === "unsubscribeconfirm" && query.user) {
    // get the first form inside the page
    let newsletterForms = document.querySelectorAll('[data-newsletter-form-wrapper][data-form-type="unsubscribe"]');
    let websiteDomain = newsletterForms[0].getAttribute("data-website-domain");
    let pageLang = newsletterForms[0].getAttribute("data-page-lang");
    let child = document.createElement("div");
    child.setAttribute("data-result-container", "");
    child.innerHTML = "Loading...";
    newsletterForms[0].appendChild(child);
    // try to confirm the form subscription
    executeUnsubscribeConfirmAction(query.user, websiteDomain, pageLang).then(res => {
      let resUnserialized = unserialize(res);
      let resultText = unserialize(resUnserialized.result);
      newsletterForms[0].querySelector("[data-result-container]").remove();
      let c = document.createElement("div");
      c.innerHTML = resultText;
      newsletterForms[0].appendChild(c);
    }).catch(e => {});
  }
};
const initSubscribeForms = function () {
  let newsletterForms = document.querySelectorAll('[data-newsletter-form-wrapper][data-form-type="subscribe"]');
  if (newsletterForms.length) {
    new SubscribeForm(newsletterForms[0]);
  }
};
const initUnsubscribeForms = function () {
  let newsletterForms = document.querySelectorAll('[data-newsletter-form-wrapper][data-form-type="unsubscribe"]');
  if (newsletterForms.length) {
    new UnsubscribeForm(newsletterForms[0]);
  }
};
export { initConfirmAction, initSubscribeForms, initUnsubscribeForms };